// Shared number, currency and identifier helpers.
// Centralised here so calculators, payslips and bulk flows format values
// identically and any change lives in a single place.

/**
 * Formats a number using Kenyan grouping with two decimal places.
 * Used for all money display across calculators and payslips.
 */
export function formatMoney(amount: number): string {
  return new Intl.NumberFormat("en-KE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Formats a decimal rate (e.g. 0.25) as a percentage string (e.g. "25.0%").
 */
export function formatPercent(rate: number): string {
  return `${(rate * 100).toFixed(1)}%`;
}

/**
 * Adds thousand separators to a raw numeric input string while the user types,
 * preserving a single trailing decimal portion.
 */
export function formatInputValue(value: string): string {
  const num = value.replace(/[^0-9.]/g, "");
  if (!num) return "";
  const parts = num.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.length > 1 ? `${parts[0]}.${parts[1]}` : parts[0];
}

/**
 * Parses a formatted input string back into a number, returning 0 when empty.
 */
export function parseInputValue(value: string): number {
  return parseFloat(value.replace(/,/g, "")) || 0;
}

/**
 * Generates a unique id, preferring crypto.randomUUID() where available and
 * falling back for non-HTTPS contexts where randomUUID is undefined.
 */
export function generateId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
}
